var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 0.333374C3.31767 0.333374 0.333008 3.31804 0.333008 7.00004C0.333008 10.682 3.31767 13.6667 6.99967 13.6667C10.6817 13.6667 13.6663 10.682 13.6663 7.00004C13.6663 3.31804 10.6817 0.333374 6.99967 0.333374ZM10.8043 5.47137L6.13767 10.138C6.00767 10.268 5.83701 10.3334 5.66634 10.3334C5.49567 10.3334 5.32501 10.268 5.19501 10.138L3.19501 8.13804C2.93434 7.87737 2.93434 7.45604 3.19501 7.19537C3.45567 6.93471 3.87701 6.93471 4.13767 7.19537L5.66634 8.72404L9.86167 4.52871C10.1223 4.26804 10.5437 4.26804 10.8043 4.52871C11.065 4.78937 11.065 5.21071 10.8043 5.47137Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.0536bf30f501441ac01e512ccfd787b2.svg";
export { ForwardRef as ReactComponent };